import gql from 'graphql-tag';

import { companyFragment } from '~/shared/graphql-queries/companies/index';

export default gql`
  query findByIdCompanyQuery($_id: MongoID!) {
    findByIdCompanyQuery(_id: $_id) {
      ...CompanyFragment
    }
  }
  ${companyFragment}
`;
